import { Injectable } from '@angular/core';

// Must match the name of the contact custom field (type: Teammate) in Front.
// A Front rule uses it to assign the chat to that teammate.
export const FRONT_DISPATCHER_CUSTOM_FIELD = 'Dispatcher';

@Injectable({
  providedIn: 'root',
})
export class FrontChatService {
  private isInitialized = false;
  // undefined = nothing to send, null = clear the field
  private pendingDispatcherEmail: string | null | undefined;

  markInitialized(): void {
    this.isInitialized = true;
    if (this.pendingDispatcherEmail !== undefined) {
      this.sendDispatcherEmail(this.pendingDispatcherEmail);
      this.pendingDispatcherEmail = undefined;
    }
  }

  reset(): void {
    this.isInitialized = false;
  }

  setDispatcherEmail(email: string | null | undefined): void {
    const value = email?.trim() || null;
    if (!this.isInitialized) {
      this.pendingDispatcherEmail = value;
      return;
    }
    this.sendDispatcherEmail(value);
  }

  clearDispatcherEmail(): void {
    this.setDispatcherEmail(null);
  }

  private sendDispatcherEmail(email: string | null): void {
    (document.defaultView as any)?.FrontChat?.('identity', {
      customFields: { [FRONT_DISPATCHER_CUSTOM_FIELD]: email },
    });
  }
}
